<div class="wrap">
  <div class="container">
    <div class="bg-vector" aria-hidden="true">
      <img src="/assets/fondo_promotor.webp" alt="" />
    </div>

    <header class="reveal delay-100" #animatedElement>
      <button
        type="button"
        class="hamburger"
        aria-label="Menú"
        (click)="toggleMenu()"
        [attr.aria-expanded]="isMenuOpen"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="brand" aria-label="teu">
        <img class="brand-img" src="/assets/logoteu.png" alt="" />
      </div>

      <nav
        class="nav-pill"
        aria-label="Navegación"
        [class.is-open]="isMenuOpen"
      >
        <a href="/cliente">
          <span class="dot"
            ><img src="/assets/logo_teu_white_green.png" alt=""
          /></span>
          Crédito
        </a>
        <a href="/promotor">
          <span class="dot"
            ><img src="/assets/logo_teu_white_green.png" alt=""
          /></span>
          Ser PromoTeur
        </a>
        <!--<a href="#contacto" (click)="isMenuOpen = false">
          <span class="dot"
            ><img src="/assets/logo_teu_white_green.png" alt=""
          /></span>
          Contacto
        </a>-->
      </nav>
    </header>

    <main>
      <section class="copy reveal delay-200" #animatedElement >
        <h1>SE UN<br /><span>PROMO</span>TEUR</h1>
        <p>
          Y empieza a <strong>ganar</strong><br />
          <strong>ingresos recurrentes</strong>, y <br />
          comisiones por el <br />
          desempeño de tu cartera.
        </p>

        <button class="cta" type="button" (click)="goToPromotorForm()" (mouseenter)="animateOnHover($event)">Ser un PromoTeur</button>
      </section>

      <section class="hero-right reveal delay-300" aria-label="Imagen principal" #animatedElement>
        <!-- Imagen solo para mobile -->
        <img
          src="/assets/fondo_promotor_responsive.webp"
          alt=""
          class="mobile-img-block"
          style="display: none"
        />
        <style>
          @media (max-width: 980px) {
            .hero-right .mobile-img-block {
              display: block !important;
            }
          }
        </style>
      </section>
    </main>
  </div>
  <section class="credito-section" id="credito">
    <div class="credito-inner">
      <div class="credito-head reveal delay-100" #animatedElement>
        <div class="mini-mark">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none"
          >
            <path
              d="M20.8611 42C20.1525 42 19.4483 42 18.7397 42C17.489 41.9683 16.2953 41.4716 15.3928 40.6074C14.4903 39.7431 13.9442 38.5737 13.8616 37.3285C13.7896 35.7225 13.7896 34.1151 13.8616 32.5063C13.9653 30.3817 15.8535 28.3519 18.0181 28.0201C18.3271 27.975 18.6391 27.9534 18.9514 27.9555H22.7882C23.9548 27.9732 25.0906 27.5816 25.9972 26.8491C26.9038 26.1165 27.5236 25.0896 27.7483 23.9477C27.8126 23.643 27.8445 23.3325 27.8433 23.0211C27.8433 21.6852 27.8433 20.345 27.8433 19.009C27.8434 17.7563 27.3642 16.5508 26.5034 15.6386C25.6426 14.7264 24.4652 14.1763 23.2116 14.1006C21.7987 14.0101 20.3815 14.0402 18.9687 14.0704C17.7514 14.0835 16.5699 13.6598 15.6396 12.8767C14.7093 12.0936 14.0921 11.0031 13.9005 9.80402C13.8517 9.46435 13.8286 9.1215 13.8314 8.77837C13.8314 7.42089 13.7882 6.06341 13.8616 4.70593C13.9364 3.57647 14.39 2.50495 15.1494 1.66383C15.9088 0.822721 16.9299 0.260952 18.0484 0.0689513C18.2936 0.024458 18.5423 0.00138679 18.7915 0C20.1871 0 21.5784 0 22.9739 0C24.2843 0.0166749 25.5365 0.542401 26.4644 1.46543C27.3922 2.38847 27.9226 3.63603 27.9427 4.94295C27.9427 6.23579 27.9427 7.55879 27.9427 8.86456C27.9034 10.0813 28.3168 11.2696 29.1033 12.2005C29.8899 13.1314 30.994 13.7391 32.2029 13.9066C32.4491 13.9403 32.6976 13.9548 32.9461 13.9497H36.7872C38.0062 13.9311 39.1916 14.3492 40.1279 15.1281C41.0642 15.907 41.6894 16.995 41.8899 18.1945C41.9223 18.368 41.9397 18.5439 41.9417 18.7203C41.9417 20.4699 42.1232 22.2325 41.8423 23.9692C41.6491 25.011 41.1244 25.963 40.3462 26.6841C39.568 27.4052 38.5775 27.857 37.5217 27.9727C35.9965 28.1278 34.4669 28.0072 32.9374 28.0287C32.4484 28.032 31.9618 28.0986 31.49 28.227C30.4774 28.5329 29.5884 29.152 28.9516 29.9948C28.3148 30.8376 27.963 31.8604 27.947 32.9157C27.947 34.2861 27.947 35.6522 27.947 37.0226C27.9371 38.1636 27.5387 39.2674 26.8173 40.153C26.0958 41.0386 25.0941 41.6534 23.9763 41.8966C23.6829 41.9633 23.383 41.998 23.082 42H20.8611Z"
              fill="#C8E357"
            />
            <path
              d="M0.00273281 20.7983C0.0406484 20.0796 -0.0562474 19.1811 0.0574994 18.2914C0.200266 17.1553 0.709265 16.1032 1.50129 15.3071C2.29331 14.511 3.32151 14.0179 4.41779 13.9085C6.08493 13.7727 7.75973 13.7727 9.42686 13.9085C10.5339 14.0361 11.5649 14.5563 12.3467 15.3816C13.1285 16.2069 13.6133 17.287 13.7198 18.4404C13.8377 20.1767 13.8377 21.9196 13.7198 23.6559C13.5938 24.7752 13.1142 25.8192 12.3563 26.6243C11.5985 27.4294 10.6051 27.95 9.53218 28.1045C8.01977 28.2667 6.49472 28.1439 4.97389 28.1702C4.33408 28.1728 3.70001 28.0447 3.1076 27.7933C2.20408 27.4144 1.42823 26.7664 0.877365 25.9306C0.326503 25.0947 0.0251659 24.1083 0.0111587 23.0949C-0.00147984 22.3893 0.00273281 21.6793 0.00273281 20.7983Z"
              fill="white"
            />
          </svg>
        </div>

        <h2 class="credito-title">GANA HASTA</h2>
      </div>

      <div
        class="credito-amount-card reveal delay-200"
        aria-label="Gana hasta veintiocho mil pesos al mes"
        #animatedElement
      >
        <span class="credito-amount-currency">$</span>
        <span class="credito-amount-value">28,000.00</span>
        <span class="credito-amount-unit">MXN</span>
      </div>

      <p class="credito-label reveal delay-300" #animatedElement>
        AL MES <span class="credito-asterisk">*</span>
      </p>

      <p class="credito-description reveal delay-400" #animatedElement>
        Tus ingresos aumentan según tu desempeño: mientras más créditos coloques
        y mejor rindan, más ganas. Las ganancias pueden variar según tu nivel de
        colocación y la calidad de tu cartera.
      </p>
    </div>
  </section>

  <section class="grupo-section">
    <div class="grupo-banner reveal delay-100" #animatedElement>
      <div class="grupo-banner-card">
        <div class="grupo-banner-card-inner">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none"
          >
            <path
              d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
              fill="#596AFD"
            />
            <path
              d="M0.00273281 20.7983C0.0406484 20.0796 -0.0562474 19.1811 0.0574994 18.2914C0.200266 17.1553 0.709265 16.1032 1.50129 15.3071C2.29331 14.511 3.32151 14.0179 4.41779 13.9085C6.08493 13.7727 7.75973 13.7727 9.42686 13.9085C10.5339 14.0361 11.5649 14.5563 12.3467 15.3816C13.1285 16.2069 13.6133 17.287 13.7198 18.4404C13.8377 20.1767 13.8377 21.9196 13.7198 23.6559C13.5938 24.7752 13.1142 25.8192 12.3563 26.6243C11.5985 27.4294 10.6051 27.95 9.53218 28.1045C8.01977 28.2667 6.49472 28.1439 4.97389 28.1702C4.33408 28.1728 3.70001 28.0447 3.1076 27.7933C2.20408 27.4144 1.42823 26.7664 0.877365 25.9306C0.326503 25.0947 0.0251659 24.1083 0.0111587 23.0949C-0.00147984 22.3893 0.00273281 21.6793 0.00273281 20.7983Z"
              fill="#1E1349"
            />
          </svg>
          <p class="grupo-banner-title">
            ¡QUIERO <br />
            SER UN <br />
            <span>PROMO</span>TEUR!
          </p>
        </div>
      </div>
    </div>
    <div class="grupo-inner">
      <div class="rb-grid">
        <div class="rb-col reveal delay-200" #animatedElement>
          <h3 class="rb-title">¿Qué necesitas?</h3>
          <div class="rb-list" role="list" >
            <div class="rb-item" role="listitem" (mouseenter)="animateOnHover($event)">
              <div class="rb-icon" aria-hidden="true">
                <img src="assets/icon1.png" alt="credit-card" />
              </div>
              <div class="rb-text">TENER UNA CARTERA RENTABLE DE CLIENTES</div>
            </div>
            <div class="rb-item" role="listitem" (mouseenter)="animateOnHover($event)">
              <div class="rb-icon" aria-hidden="true">
                <img src="assets/icon2.png" alt="flexibility" />
              </div>
              <div class="rb-text">FLEXIBILIDAD PARA GESTIONAR TU TIEMPO</div>
            </div>
            <div class="rb-item" role="listitem" (mouseenter)="animateOnHover($event)">
              <div class="rb-icon" aria-hidden="true">
                <img src="assets/icon3.png" alt="quality" />
              </div>
              <div class="rb-text">
                ALTOS ESTÁNDARES DE CALIDAD Y ENFOQUE EN RESULTADOS
              </div>
            </div>
          </div>
        </div>
        <div class="rb-col reveal delay-300" #animatedElement>
          <h3 class="rb-title">Beneficios</h3>
          <div class="rb-list" role="list">
            <div class="rb-item" role="listitem" (mouseenter)="animateOnHover($event)">
              <div class="rb-icon" aria-hidden="true">
                <img src="assets/icon4.png" alt="flexibility" />
              </div>
              <div class="rb-text">FLEXIBILIDAD PARA ORGANIZAR TU TIEMPO</div>
            </div>
            <div class="rb-item" role="listitem" (mouseenter)="animateOnHover($event)">
              <div class="rb-icon" aria-hidden="true">
                <img src="assets/icon5.png" alt="profit" />
              </div>
              <div class="rb-text">GANANCIAS CLARAS Y JUSTAS</div>
            </div>
            <div class="rb-item" role="listitem" (mouseenter)="animateOnHover($event)">
              <div class="rb-icon" aria-hidden="true">
                <img src="assets/icon6.png" alt="profit" />
              </div>
              <div class="rb-text">OPORTUNIDAD DE AUMENTAR TUS GANANCIAS</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="valores" class="valores-section">
    <div class="valores-inner">
      <div class="valores-left-card reveal delay-100" #animatedElement>
        <img
          src="/assets/img_teu_promoteurs.webp"
          alt="Valores Teu"
          class="valores-left-img"
        />
        <div class="valores-left-overlay">
          <div aria-hidden="true">
            <img src="/assets/logo.png" alt="" />
            <h2 class="valores-left-title">VALORES TEU</h2>
          </div>

          <p class="valores-left-sub">Las 3 “i”s que nos definen:</p>
        </div>
      </div>

      <div class="valores-right">
        <article class="valor-card valor-card-integridad reveal delay-200" #animatedElement>
          <h3 class="valor-title">INTEGRIDAD</h3>
          <p class="valor-text">
            Actuamos con <strong>honestidad</strong> y
            <strong>transparencia</strong>. Cumplimos lo que prometemos y
            tomamos siempre la <strong>decisión correcta</strong>.
          </p>
        </article>

        <article class="valor-card valor-card-innovacion reveal delay-300" #animatedElement>
          <h3 class="valor-title">INNOVACIÓN</h3>
          <p class="valor-text">
            Pensamos diferente para mejorar continuamente. Creamos
            <strong>soluciones simples</strong> que nos permiten crecer y servir
            mejor.
          </p>
        </article>

        <article class="valor-card valor-card-inclusion reveal delay-400" #animatedElement>
          <h3 class="valor-title">INCLUSIÓN</h3>
          <p class="valor-text">
            Creemos en el <strong>respeto</strong>, la
            <strong>empatía</strong> y el <strong>trabajo en equipo</strong>.
            Cada persona y cada voz cuentan.
          </p>
        </article>
      </div>
    </div>
  </section>

  <section class="social-media">
    <div class="social-media-inner reveal delay-100" #animatedElement>
      <div class="social-media-header-icon" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 42 42"
          fill="none"
        >
          <path
            d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
            fill="#C8E357"
          />
          <path
            d="M0.00273281 20.7983C0.0406484 20.0796 -0.0562474 19.1811 0.0574994 18.2914C0.200266 17.1553 0.709265 16.1032 1.50129 15.3071C2.29331 14.511 3.32151 14.0179 4.41779 13.9085C6.08493 13.7727 7.75973 13.7727 9.42686 13.9085C10.5339 14.0361 11.5649 14.5563 12.3467 15.3816C13.1285 16.2069 13.6133 17.287 13.7198 18.4404C13.8377 20.1767 13.8377 21.9196 13.7198 23.6559C13.5938 24.7752 13.1142 25.8192 12.3563 26.6243C11.5985 27.4294 10.6051 27.95 9.53218 28.1045C8.01977 28.2667 6.49472 28.1439 4.97389 28.1702C4.33408 28.1728 3.70001 28.0447 3.1076 27.7933C2.20408 27.4144 1.42823 26.7664 0.877365 25.9306C0.326503 25.0947 0.0251659 24.1083 0.0111587 23.0949C-0.00147984 22.3893 0.00273281 21.6793 0.00273281 20.7983Z"
            fill="white"
          />
        </svg>
        <h2 class="social-media-title">EQUIPO DE <span>PROMO</span>TEURS</h2>
      </div>
    </div>

    <div class="social-media-gallery reveal delay-300" #animatedElement>
      <app-tiktok-carousel
        title="Últimos TikToks"
        [items]="tiktoks"
      ></app-tiktok-carousel>
    </div>
  </section>
  <section id="cartera" class="cartera-section">
    <div class="cartera-inner">
      <div class="cartera-header reveal delay-100" #animatedElement>
        <div class="cartera-mark" aria-hidden="true">
          <img src="/assets/logo.png" alt="" />
        </div>
        <h2 class="cartera-title">GESTIONA TU CARTERA CON FACILIDAD</h2>
      </div>

      <div class="cartera-features" role="list">
        <article class="cartera-card reveal delay-200" role="listitem" #animatedElement>
          <div class="cartera-icon">
            <span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 70 60"
                fill="none"
              >
                <path
                  d="M53.9585 26.25C54.9432 26.25 55.8955 26.1105 56.7964 25.8503C56.8486 26.4666 56.8752 27.09 56.8752 27.7197V39.382L61.0119 48.5989C61.172 48.9557 61.2548 49.3424 61.2548 49.7335C61.2548 51.2639 60.0144 52.5044 58.484 52.5044H11.5274C11.1372 52.5044 10.7514 52.4221 10.3952 52.2626C8.99852 51.6372 8.37312 49.9981 8.9984 48.6013L13.1252 39.3832L13.1255 27.682L13.1384 26.9531C13.544 15.1968 23.2048 5.84473 35.0002 5.84473C39.2098 5.84473 43.142 7.03388 46.4787 9.09459C44.7856 10.9167 43.7502 13.3582 43.7502 16.0417C43.7502 21.6796 48.3206 26.25 53.9585 26.25ZM43.6285 55.4254C42.9323 59.5615 39.3343 62.7127 35.0002 62.7127C30.666 62.7127 27.0679 59.5615 26.3719 55.4254H43.6285ZM53.9585 23.3333C57.9855 23.3333 61.2502 20.0687 61.2502 16.0417C61.2502 12.0146 57.9855 8.74999 53.9585 8.74999C49.9315 8.74999 46.6668 12.0146 46.6668 16.0417C46.6668 20.0687 49.9315 23.3333 53.9585 23.3333Z"
                  fill="#212121"
                /></svg
            ></span>
          </div>
          <p class="cartera-text">
            <strong>Recordatorios automáticos</strong> de pago<br />
            para tus clientes
          </p>
        </article>

        <article class="cartera-card reveal delay-300" role="listitem" #animatedElement>
          <div class="cartera-icon">
            <span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 70 60"
                fill="none"
              >
                <path
                  d="M63.3135 9.60426C62.1745 8.46525 60.3277 8.46525 59.1888 9.60426L55.4178 13.3752L54.5635 12.5209C53.4245 11.3819 51.5777 11.3819 50.4388 12.5209C49.2998 13.66 49.2998 15.5067 50.4388 16.6457L53.3554 19.5624C54.4944 20.7014 56.3412 20.7014 57.4802 19.5624L63.3135 13.7291C64.4525 12.59 64.4525 10.7433 63.3135 9.60426ZM8.74967 49.5638H40.8444C42.4553 49.5638 43.7611 50.8696 43.7611 52.4805C43.7611 53.9761 42.6352 55.209 41.1845 55.3776L40.8444 55.3971H8.74967C7.13886 55.3971 5.83301 54.0913 5.83301 52.4805C5.83301 50.9848 6.95896 49.7519 8.40953 49.5833L8.74967 49.5638ZM8.74967 32.0833H40.8444C42.4553 32.0833 43.7611 33.3891 43.7611 35C43.7611 36.4957 42.6352 37.7285 41.1845 37.8971L40.8444 37.9167H8.74967C7.13886 37.9167 5.83301 36.6109 5.83301 35C5.83301 33.5043 6.95896 32.2715 8.40953 32.1029L8.74967 32.0833ZM8.74967 14.5834H40.8444C42.4553 14.5834 43.7611 15.8893 43.7611 17.5001C43.7611 18.9959 42.6352 20.2287 41.1845 20.3972L40.8444 20.4168H8.74967C7.13886 20.4168 5.83301 19.1109 5.83301 17.5001C5.83301 16.0043 6.95896 14.7715 8.40953 14.6031L8.74967 14.5834ZM59.1888 47.521C60.3277 46.382 62.1745 46.382 63.3135 47.521C64.4525 48.6599 64.4525 50.5067 63.3135 51.6457L57.4802 57.479C56.3412 58.618 54.4944 58.618 53.3554 57.479L50.4388 54.5624C49.2998 53.4234 49.2998 51.5766 50.4388 50.4376C51.5777 49.2987 53.4245 49.2987 54.5635 50.4376L55.4178 51.2919L59.1888 47.521Z"
                  fill="#212121"
                /></svg
            ></span>
          </div>
          <p class="cartera-text">
            <strong>Evaluación inteligente</strong> de<br />
            nuevos prospectos
          </p>
        </article>

        <article class="cartera-card" role="listitem">
          <div class="cartera-icon">
            <span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 70 60"
                fill="none"
              >
                <path
                  d="M40.658 14.583L55.4193 29.3443L26.4329 58.3304C25.6254 59.1377 24.6211 59.7208 23.5193 60.0212L8.5985 64.0905C6.96551 64.5359 5.46713 63.0373 5.91251 61.4046L9.98178 46.4838C10.2823 45.3819 10.8651 44.3777 11.6727 43.57L40.658 14.583ZM19.0333 32.083L14.6583 36.458L8.02292 36.4592C6.81478 36.4592 5.83542 35.4798 5.83542 34.2717C5.83542 33.0636 6.81478 32.0842 8.02292 32.0842L19.0333 32.083ZM60.8944 8.24131L61.3407 8.66241L61.7615 9.10858C65.4112 13.2072 65.2709 19.4923 61.3407 23.4227L58.5109 26.2496L43.7497 11.4913L46.5803 8.66241C50.5108 4.73206 56.7959 4.59168 60.8944 8.24131ZM30.6999 20.4163L26.325 24.7913L8.02292 24.7925C6.81478 24.7925 5.83542 23.8132 5.83542 22.605C5.83542 21.3969 6.81478 20.4175 8.02292 20.4175L30.6999 20.4163ZM42.3666 8.74965L37.9916 13.1246L8.02292 13.1259C6.81478 13.1259 5.83542 12.1465 5.83542 10.9384C5.83542 9.73026 6.81478 8.75088 8.02292 8.75088L42.3666 8.74965Z"
                  fill="#212121"
                /></svg
            ></span>
          </div>
          <p class="cartera-text">
            <strong>Toda la información que necesitas</strong>,<br />
            en un solo lugar
          </p>
        </article>
      </div>

      <div class="cartera-banner reveal delay-400" #animatedElement>
        <img
          src="/assets/team_teu.webp"
          alt="Equipo Teu"
          class="cartera-banner-img"
        />
        <div class="cartera-banner-card">
          <p class="cartera-banner-small">Únete a nuestro equipo y</p>
          <p class="cartera-banner-main">sé tu propio jefe</p>
          <p class="cartera-banner-sub">¡GANA POR LO QUE TRABAJES!</p>
        </div>
      </div>
    </div>
  </section>
  <!--<section class="faq" id="faq">
    <div class="faq-inner">
      <div class="faq-header-icon reveal delay-100" aria-hidden="true" #animatedElement>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="42"
          viewBox="0 0 42 42"
          fill="none"
        >
          <path
            d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
            fill="#596AFD"
          />
          <path
            d="M0.00273281 20.7993C0.0406484 20.0805 -0.0562474 19.182 0.0574994 18.2923C0.200266 17.1563 0.709265 16.1042 1.50129 15.3081C2.29331 14.5119 3.32151 14.0189 4.41779 13.9095C6.08493 13.7736 7.75973 13.7736 9.42686 13.9095C10.5339 14.0371 11.5649 14.5573 12.3467 15.3825C13.1285 16.2078 13.6133 17.288 13.7198 18.4414C13.8377 20.1777 13.8377 21.9206 13.7198 23.6569C13.5938 24.7761 13.1142 25.8202 12.3563 26.6253C11.5985 27.4304 10.6051 27.951 9.53218 28.1055C8.01977 28.2676 6.49472 28.1449 4.97389 28.1712C4.33408 28.1738 3.70001 28.0457 3.1076 27.7943C2.20408 27.4154 1.42823 26.7674 0.877365 25.9316C0.326503 25.0957 0.0251659 24.1092 0.0111587 23.0959C-0.00147984 22.3903 0.00273281 21.6803 0.00273281 20.7993Z"
            fill="#1E1349"
          />
        </svg>
        <h2 class="faq-title reveal delay-200" #animatedElement>PREGUNTAS <br />FRECUENTES</h2>
      </div>

      <div class="faq-list reveal delay-300" role="list" #animatedElement>
        @for (item of faqItems; track item.question; let i = $index) {
          <div
            class="faq-item"
            role="listitem"
            [class.is-open]="openFaqIndex === i"
          >
            <button
              type="button"
              class="faq-item-header"
              (click)="toggleFaq(i)"
              [attr.aria-expanded]="openFaqIndex === i"
            >
              <span class="faq-question">{{ item.question }}</span>
              <span class="faq-chevron" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="9"
                  viewBox="0 0 16 9"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.3457 0L15.1084 1.66737L7.55418 8.81325L-3.62396e-05 1.66737L1.76261 0L7.55418 5.47851L13.3457 0Z"
                    fill="#1E1349"
                  />
                </svg>
              </span>
            </button>
            @if (openFaqIndex === i) {
              <div class="faq-item-body">
                <p>{{ item.answer }}</p>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </section>-->
  <app-footer [colorClass]="footerColorClass"></app-footer>
</div>
<script>
  (function () {
    var montoInput = document.getElementById("simula-monto");
    var semanasSelect = document.getElementById("simula-semanas");
    var pagoSemanalEl = document.getElementById("simula-pago-semanal");
    var totalPagarEl = document.getElementById("simula-total-pagar");
    var form = document.getElementById("simula-form");
    var tasaSemanal = 0.023;

    function formatoMonto(valor) {
      return valor.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    function recalcular() {
      var bruto = String(montoInput.value || "").replace(/,/g, "");
      var monto = parseFloat(bruto);
      if (!isFinite(monto) || monto < 0) monto = 0;
      var semanas = parseInt(semanasSelect.value, 10);
      if (!isFinite(semanas) || semanas <= 0) semanas = 1;

      var total = monto * (1 + tasaSemanal * semanas);
      var pago = total / semanas;

      if (!isFinite(total)) total = 0;
      if (!isFinite(pago)) pago = 0;

      pagoSemanalEl.textContent = formatoMonto(pago);
      totalPagarEl.textContent = formatoMonto(total);
    }

    montoInput.addEventListener("input", recalcular);
    semanasSelect.addEventListener("change", recalcular);
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      recalcular();
    });

    recalcular();
  })();
</script>
